var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineWifiRouterSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.233 2.753a3.92 3.92 0 0 1 5.534 0a.75.75 0 0 0 1.06-1.06a5.42 5.42 0 0 0-7.655 0a.75.75 0 1 0 1.061 1.06M6.95 6.266a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m.995-2.048c-.527-.527-1.46-.527-1.987 0a.75.75 0 1 1-1.06-1.06c1.113-1.114 2.995-1.114 4.108 0a.75.75 0 0 1-1.06 1.06M1.99 2.981a.75.75 0 1 0-1.447.395L1.599 7.25h1.554zm11.469.395L12.4 7.25h-1.554l1.164-4.269a.75.75 0 0 1 1.447.395m-11.03 9.838V12.5H1.5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.927v.714a.75.75 0 0 1-1.5 0V12.5H3.927v.714a.75.75 0 0 1-1.5 0m.25-2.867a.5.5 0 0 1 .5-.5h.478a.5.5 0 1 1 0 1h-.478a.5.5 0 0 1-.5-.5m2.89-.5a.5.5 0 1 0 0 1h.477a.5.5 0 1 0 0-1z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineWifiRouterSolid);
export default __webpack_public_path__ + "static/media/StreamlineWifiRouterSolid.16d89c3cfe1be7af7dc05a8ad1b5bb23.svg";
export { ForwardRef as ReactComponent };